import Common from '../common/Common';

class Modal {
    constructor() {
        this.hasNcuiModal = !!window?.ncui?.modal;
    }

    getParam(options) {
        const com = Common.instance;
        const l10nData = com.l10nData || {};
        const defaultOption = {
            customClass: 'cnb-modal',
            showCloseButton: false,
            position: 'center',
            isVertical: true,
            title: null,
            allowOutsideClick: true,
            confirmButtonText: l10nData?.Common['OK'], // l10n 적용 필요
            cancelButtonText: l10nData?.Common['Cancel'], // l10n 적용 필요
            allowEscapeKey: true,
            allowEnterKey: true
        }
        const option = Object.assign({}, defaultOption, options);
        const { title = '', html = '' } = option || {};
        let param = this.hasNcuiModal ? option : `${title} ${html}`;

        if(!param || !title) {
            throw new Error('모달을 노출하기 위한 옵션 / title 값이 없습니다.');
        }

        if(this.hasNcuiModal) {
            param.title = title?.replace(/\n/g, '<br/>');
            param.html = html?.replace(/\n/g, '<br/>');
        } else {
            param = param.replace(/<[^>]+>/g, ''); // html 태그 제거
        }

        return param;
    }

    setPickIsConfirmed(result) {
        const isResultBoolean = typeof result === 'boolean';
        const hasIsConfirmed = this.hasNcuiModal && typeof result?.isConfirmed === 'boolean';

        return isResultBoolean ? result : (hasIsConfirmed ? result?.isConfirmed : false);
    }

    async openModal(modalUi, systemUi, option) {
        try {
            const param = this.getParam(option);
            if(this.hasNcuiModal && !!modalUi) {
                const modal = new modalUi();
                return await modal.open(param);
            } else if(!!systemUi) {
                return systemUi(param); // ncui modal 객체가 없으면 시스템 ui 사용
            } else {
                throw new Error('window.ncui.modal / 시스템 ui가 없습니다.');
            }
        } catch(error) {
            console.error(error);
        }
    }

    async openAlert(option) {
        await this.openModal(window?.ncui?.modal?.uiAlert, window.alert, option);
    }

    async openConfirm(option) {
        const result = await this.openModal(window?.ncui?.modal?.uiConfirm, window.confirm, option); // ncui modal은 promise 반환
        return this.setPickIsConfirmed(result);
    }
}

export default new Modal();